/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoggerService } from '../../../../modules/shared/services/logger.service';
import { BeginLogout } from '../../state/authState.actions';
import { Observable } from 'rxjs';
import { AuthState } from '../../state/authState.state';
import { MatDialog } from '@angular/material/dialog';
import { LogoutDialogComponent } from './logout-dialog.component';
import { Navigate } from '@ngxs/router-plugin';
import { filter, mergeMap, take } from 'rxjs/operators';
import { MapToolbarWidgetComponent } from '../../../../modules/map/toolbar/widget/map-toolbar-widget.component';
import { HotKeyService } from '../../../ui/hotkeys/hot-key.service';
import { AuthenticatedUser } from '../../state/authState.model';
import { LogoutService } from './logout.service';

@Component({
    selector: 'dash-gis-logout',
    templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {

    @Input() showIcon = false;
    @Input() inMenu = false;

    constructor(
        private logoutService: LogoutService,
    ) {
    }

    ngOnInit() {}

    public showLogout() {
        this.logoutService.doLogout();
    }
}
